/*
  VOLT slide cart: one-tap add for "Complete the kit" (snippets/cart-drawer.liquid).
  Adds the variant and re-renders the drawer in place, keeping it open
  (renderContents(..., false) does not toggle the drawer). Quantities and
  remove are the theme's own cart.js.
*/
(() => {
  if (window.voltCartReady) return;
  window.voltCartReady = true;
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-vcart-add]');
    if (!btn) return;
    e.preventDefault();
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    const label = btn.textContent;
    btn.textContent = 'Adding…';
    try {
      const sections = drawer.getSectionsToRender().map((s) => s.id);
      const res = await fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.vcartAdd), quantity: 1 }], sections, sections_url: window.location.pathname }),
      });
      const json = await res.json();
      if (!res.ok || json.status) throw new Error(json.description || 'Could not add');
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'volt-cart', cartData: json });
      }
      drawer.classList.remove('wt-cart--empty');
      drawer.renderContents(json, false);
    } catch (err) {
      btn.textContent = 'Try again';
      btn.removeAttribute('aria-busy');
      return;
    }
    btn.textContent = label;
  });
})();
